/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AdDesignDestroyPathParams, AdDesignDestroyResponse } from '../types/AdDesignDestroy'

/**
 * DELETE /organisations/:organisation/ad-designs/:adDesign
 * @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::destroy
 */
export async function adDesignDestroy(
	organisation: AdDesignDestroyPathParams['organisation'],
	adDesign: AdDesignDestroyPathParams['adDesign'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AdDesignDestroyResponse>> {
	return axiosInstance.delete(`/organisations/${organisation}/ad-designs/${adDesign}`, config)
}
